var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"cust-btn-color",on:{"click":_vm.onPrint}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" mdi-printer ")]),_vm._v("purchase order ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }